import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601DateTime: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Time: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type Query = {
  __typename?: 'Query';
  /**
   * Find artist settlement by ID
   * @deprecated Moved to eventArtistSettlement on AppSchema (x-vp-api: admin). Removed once the admin SPA migrates.
   */
  eventArtistSettlement?: Maybe<Settlement>;
  /** @deprecated Moved to currentUser on AppSchema (x-vp-api: admin). Still read by the ticket-buyer app; CustomerSchema publishes no me/currentUser counterpart yet, so this cannot be removed until that surface exists. */
  me?: Maybe<Me>;
  /**
   * Find offer sheet by ID
   * @deprecated Moved to offerSheet on AppSchema (x-vp-api: admin), except that the admin offer-sheet rendering path still reads htmlContent/pdfDownloadUrl here and App::Offer::SheetType republishes neither. Removed once the AppSchema offer type carries what that rendering path needs.
   */
  offerSheet?: Maybe<Sheet>;
  /** Returns paginated list of found orders, according to parameters */
  paginatedEventOrders?: Maybe<EventOrdersCollection>;
  /** Returns paginated list of found events, according to parameters */
  paginatedEvents?: Maybe<PublicEventCollection>;
  /** Returns paginated list of found events, according to parameters */
  protectedEvents?: Maybe<ProtectedEventCollection>;
  /** Returns list of found events, according to parameters */
  publicEvents?: Maybe<Array<PublicEvent>>;
  ticketbuyer?: Maybe<Ticketbuyer>;
  vpConfig?: Maybe<Config>;
};


export type QueryEventArtistSettlementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOfferSheetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPaginatedEventOrdersArgs = {
  arguments: OrdersApiArguments;
};


export type QueryPaginatedEventsArgs = {
  arguments: EventsApiArguments;
};


export type QueryProtectedEventsArgs = {
  arguments: EventsApiArguments;
};


export type QueryPublicEventsArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchScope?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type Settlement = {
  __typename?: 'Settlement';
  address?: Maybe<Address>;
  availableEvents?: Maybe<Array<Event>>;
  barDeals?: Maybe<Array<SettlementDeal>>;
  businessName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customExpenses?: Maybe<Array<CustomExpense>>;
  deals?: Maybe<Array<SettlementDeal>>;
  eventIds?: Maybe<Array<Scalars['Int']['output']>>;
  events?: Maybe<Array<Event>>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  manualTicketSales?: Maybe<Array<ManualTicketSale>>;
  payments?: Maybe<Array<Payment>>;
  pdfDownloadUrl?: Maybe<Scalars['String']['output']>;
  printableUrl?: Maybe<Scalars['String']['output']>;
  settlementType?: Maybe<SettlementTypeEnum>;
  signedContracts?: Maybe<Array<SettlementContract>>;
  taxAttachments?: Maybe<Array<SettlementAttachment>>;
  taxId?: Maybe<Scalars['String']['output']>;
  taxLabel?: Maybe<Scalars['String']['output']>;
  taxWithholdingAmount?: Maybe<Scalars['Float']['output']>;
  taxWithholdingType?: Maybe<SettlementTaxWithholdingTypeEnum>;
  ticketDeals?: Maybe<Array<SettlementDeal>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Event = {
  __typename?: 'Event';
  announceDetail?: Maybe<AnnounceDetail>;
  /** Are donations accepted for this event */
  availableForDonation?: Maybe<Scalars['Boolean']['output']>;
  /** Is processing fee applied to ticket purchases */
  availableForProcessingFee?: Maybe<Scalars['Boolean']['output']>;
  /** Is sales tax applied to ticket purchases */
  availableForSalesTax?: Maybe<Scalars['Boolean']['output']>;
  /** Additional email content */
  confirmationEmailContent?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Use start_time instead */
  date: Scalars['ISO8601Date']['output'];
  /** Text shown on the donation button at checkout */
  donationButtonText?: Maybe<Scalars['String']['output']>;
  /** Description of what the donation supports */
  donationDescription?: Maybe<Scalars['String']['output']>;
  /** Time (with date) in UTC, use event's timezone for formatting */
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Door date and time in UTC, use event's timezone for formatting */
  doorTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time (with date) in UTC, use event's timezone for formatting */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** End date and time in UTC, use event's timezone for formatting */
  endTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** List of all event artists */
  eventArtists?: Maybe<Array<EventArtist>>;
  /** Event group details */
  eventGroup?: Maybe<EventGroup>;
  /** Additional content shown in the event's footer */
  footerContent?: Maybe<Scalars['String']['output']>;
  /** Full event slug name and key */
  fullSlug?: Maybe<Scalars['String']['output']>;
  holdPreference?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Labels attached to the event */
  labels?: Maybe<Array<Label>>;
  /** Are PDF tickets mailed to attendees */
  mailPdfTickets?: Maybe<Scalars['Boolean']['output']>;
  /** Minimum age required to attend the event */
  minimumAge?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** Seating chart associated with the event */
  seatingChart?: Maybe<SeatingChart>;
  /** Whether will-call reminder emails are sent for this event */
  sendWillCallReminders?: Maybe<Scalars['Boolean']['output']>;
  /** Time (with date) in UTC, use event's timezone for formatting */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Start date and time in UTC, use event's timezone for formatting */
  startTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state?: Maybe<EventStateEnum>;
  /** Are there any tickets defined */
  ticketed?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum number of tickets that can be purchased in a single order */
  ticketLimit?: Maybe<Scalars['Int']['output']>;
  ticketSales?: Maybe<EventSales>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Event venue details */
  venue?: Maybe<Venue>;
  /** Event venue room details */
  venueRoom?: Maybe<VenueRoom>;
};


export type EventEventArtistsArgs = {
  artistId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AnnounceDetail = {
  __typename?: 'AnnounceDetail';
  announceArtists?: Maybe<Array<AnnounceArtist>>;
  announceAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  attachments?: Maybe<Array<AnnounceAttachment>>;
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Categorisation category */
  category?: Maybe<Category>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  defaultTicketsUrl?: Maybe<Scalars['String']['output']>;
  defaultTicketsUrlNewTab?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventArtists?: Maybe<Array<EventArtist>>;
  eventId?: Maybe<Scalars['Int']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  handstampUrl?: Maybe<Scalars['String']['output']>;
  highlightedImageIdx?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  onSaleAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  promoter?: Maybe<Scalars['String']['output']>;
  /** Categorisation subcategory */
  subcategory?: Maybe<Subcategory>;
  support?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  ticketsUrl?: Maybe<Scalars['String']['output']>;
  ticketsUrlType?: Maybe<TicketsUrlTypeEnum>;
  tracking?: Maybe<Array<TrackingEntry>>;
  triggeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  /** Categorisation type */
  type?: Maybe<Type>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type AnnounceArtist = {
  __typename?: 'AnnounceArtist';
  accountId: Scalars['Int']['output'];
  applemusic?: Maybe<Scalars['String']['output']>;
  bandcamp?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  lastfm?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  songkick?: Maybe<Scalars['String']['output']>;
  spotify?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  wikipedia?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type AnnounceAttachment = {
  __typename?: 'AnnounceAttachment';
  attachment: Attachment;
  attachmentId: Scalars['Int']['output'];
  highlighted?: Maybe<Scalars['Boolean']['output']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  accountId: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  derivedFromId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  status?: Maybe<AttachmentStatusEnum>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum AttachmentStatusEnum {
  Pending = 'PENDING',
  Ready = 'READY',
  Uploading = 'UPLOADING'
}

/** Category */
export type Category = {
  __typename?: 'Category';
  /** Unique identifier for the category */
  id: Scalars['String']['output'];
  /** Name of the category */
  name: Scalars['String']['output'];
  /** Subcategories belonging to this category */
  subcategories: Array<Subcategory>;
};

/** Subcategory */
export type Subcategory = {
  __typename?: 'Subcategory';
  /** Category identifier this subcategory belongs to */
  categoryId: Scalars['String']['output'];
  /** Unique identifier for the subcategory */
  id: Scalars['String']['output'];
  /** Name of the subcategory */
  name: Scalars['String']['output'];
};

export type EventArtist = {
  __typename?: 'EventArtist';
  artist: Artist;
  id: Scalars['Int']['output'];
  /** Legacy event artist, used for compatibility with settlement sheets */
  legacyEventArtistId?: Maybe<Scalars['Int']['output']>;
  /** Legacy offer sheet ID for compatibility with settlement sheets */
  legacyOfferSheetId?: Maybe<Scalars['Int']['output']>;
  /**
   * Legacy settlement sheet ID
   * @deprecated Use eventArtistSettlements(eventGroupId:, artistId:) on AppSchema (x-vp-api: admin)
   */
  legacySettlementSheetId?: Maybe<Scalars['Int']['output']>;
  riders?: Maybe<Array<EventArtistRider>>;
};

export type Artist = {
  __typename?: 'Artist';
  attachments?: Maybe<Array<ArtistAttachment>>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  links?: Maybe<Array<ArtistLink>>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ArtistAttachment = {
  __typename?: 'ArtistAttachment';
  attachment: Attachment;
  attachmentId: Scalars['Int']['output'];
};

export type ArtistLink = {
  __typename?: 'ArtistLink';
  id: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type EventArtistRider = {
  __typename?: 'EventArtistRider';
  /** Artist load in time */
  artistLoadInTime?: Maybe<Scalars['String']['output']>;
  /** Attachments for the rider */
  attachments?: Maybe<Array<Attachment>>;
  /** Number of backstage passes */
  backstagePassesNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  riderType: EventArtistRiderTypeEnum;
  /** Sound check type: "Full" or "Line" */
  soundCheckType?: Maybe<Scalars['String']['output']>;
  /** Number of performers on stage */
  stagePerformersNumber?: Maybe<Scalars['Int']['output']>;
  /** Stage sound check time */
  stageSoundCheckTime?: Maybe<Scalars['String']['output']>;
};

export enum EventArtistRiderTypeEnum {
  Hospitality = 'HOSPITALITY',
  Tech = 'TECH'
}

export enum TicketsUrlTypeEnum {
  Custom = 'CUSTOM',
  Handstamp = 'HANDSTAMP',
  NoUrl = 'NO_URL',
  VenuepilotCheckout = 'VENUEPILOT_CHECKOUT'
}

export type TrackingEntry = {
  __typename?: 'TrackingEntry';
  conversionLabel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  provider: TrackingProviderEnum;
  trackingId: Scalars['String']['output'];
};

export enum TrackingProviderEnum {
  /** Facebook Pixel */
  Facebook = 'facebook',
  /** Google Analytics */
  Ga = 'ga',
  /** Reddit Pixel */
  Reddit = 'reddit',
  /** TikTok Pixel */
  TikTok = 'tik_tok'
}

/** Type */
export type Type = {
  __typename?: 'Type';
  /** Unique identifier for the type */
  id: Scalars['String']['output'];
  /** Name of the type */
  name: Scalars['String']['output'];
};

export type EventGroup = {
  __typename?: 'EventGroup';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventIds?: Maybe<Array<Scalars['Int']['output']>>;
  events: Array<Event>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Label that can be attached to events and user roles */
export type Label = {
  __typename?: 'Label';
  /** Id of the label */
  id: Scalars['Int']['output'];
  /** Name of the label */
  name: Scalars['String']['output'];
};

/** Seating Chart data with detailed metadata and associations */
export type SeatingChart = {
  __typename?: 'SeatingChart';
  /** Whether the chart can be deleted */
  deletable: Scalars['Boolean']['output'];
  /** URL of the draft thumbnail image for the seating chart */
  draftThumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the chart has an unpublished draft */
  hasDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the seating chart */
  id: Scalars['Int']['output'];
  /** Unique key for the seating chart */
  key: Scalars['String']['output'];
  /** Chart name for the seating chart */
  name: Scalars['String']['output'];
  /** Parent seating chart ID if this is a derived chart */
  parentId?: Maybe<Scalars['Int']['output']>;
  /** URL of the published thumbnail image for the seating chart */
  publishedThumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Publication status of the chart */
  status?: Maybe<Scalars['String']['output']>;
  /** Whether the chart can be assigned to an event */
  usable: Scalars['Boolean']['output'];
};

export enum EventStateEnum {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Deleted = 'DELETED',
  Hold = 'HOLD'
}

export type EventSales = {
  __typename?: 'EventSales';
  ticketsSold?: Maybe<Scalars['Int']['output']>;
  totalSales?: Maybe<Scalars['Float']['output']>;
  totalSalesLimit?: Maybe<Scalars['Float']['output']>;
  totalTickets?: Maybe<Scalars['Int']['output']>;
  totalTicketsAvailable?: Maybe<Scalars['Int']['output']>;
  totalTicketsOnHold?: Maybe<Scalars['Int']['output']>;
  totalTicketsSales?: Maybe<Scalars['Float']['output']>;
  totalTicketsSalesToday?: Maybe<Scalars['Float']['output']>;
  totalTicketsSold?: Maybe<Scalars['Int']['output']>;
  totalTicketsSoldToday?: Maybe<Scalars['Int']['output']>;
};

export type Venue = {
  __typename?: 'Venue';
  address?: Maybe<Address>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  includeCcFee?: Maybe<Scalars['Boolean']['output']>;
  includeConvenienceFee?: Maybe<Scalars['Boolean']['output']>;
  includeTaxFee?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Attachment>;
  logoId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `logo` instead */
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processingFee?: Maybe<Scalars['Float']['output']>;
  processingFeePercentage?: Maybe<Scalars['Float']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  rooms?: Maybe<Array<VenueRoom>>;
  salesTax?: Maybe<Scalars['Float']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VenueRoom = {
  __typename?: 'VenueRoom';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  venue: Venue;
};

export type SettlementDeal = {
  __typename?: 'SettlementDeal';
  _destroy?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  attachments?: Maybe<Array<SettlementAttachment>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deal?: Maybe<Deal>;
  /** DEPRECATED */
  dealId?: Maybe<Scalars['Int']['output']>;
  dealType?: Maybe<DealEnum>;
  expenseAmount?: Maybe<Scalars['Float']['output']>;
  firstAmount?: Maybe<Scalars['Float']['output']>;
  hitAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  percent?: Maybe<Scalars['Float']['output']>;
  showTicketSales?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type SettlementAttachment = {
  __typename?: 'SettlementAttachment';
  id?: Maybe<Scalars['Int']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Deal = {
  __typename?: 'Deal';
  calculation: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  key: DealEnum;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum DealEnum {
  /** Artist Guarantee */
  ArtistGuarantee = 'artist_guarantee',
  /** Artist Guarantee plus. GBOR after Expenses */
  ArtistGuaranteePlusGborAfterExpenses = 'artist_guarantee_plus_gbor_after_expenses',
  /** Artist Guarantee vs GBOR */
  ArtistGuaranteeVsGbor = 'artist_guarantee_vs_gbor',
  /** Artist Guarantee vs GBOR after Expenses */
  ArtistGuaranteeVsGborAfterExpenses = 'artist_guarantee_vs_gbor_after_expenses',
  /** Flat fee to artist */
  FlatFee = 'flat_fee',
  /** GBOR */
  Gbor = 'gbor',
  /** GBOR after expenses */
  GborAfterExpenses = 'gbor_after_expenses',
  /** Bar Guarantee due to Venue */
  GuaranteeToVenue = 'guarantee_to_venue',
  /** None */
  None = 'none',
  /** % of F&B sales if F&B exceeds amount after amount */
  PercentAfterHit = 'percent_after_hit',
  /** % of F&B sales if F&B exceeds amount */
  PercentWithHit = 'percent_with_hit',
  /** Rental fee to Venue */
  Rental = 'rental',
  /** % of F&B sales */
  SalesPercentage = 'sales_percentage'
}

export type CustomExpense = {
  __typename?: 'CustomExpense';
  _destroy?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deductedType?: Maybe<CustomExpenseDeductedTypeEnum>;
  description?: Maybe<Scalars['String']['output']>;
  due?: Maybe<CustomExpenseDueEnum>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum CustomExpenseDeductedTypeEnum {
  Gross = 'GROSS',
  Net = 'NET'
}

export enum CustomExpenseDueEnum {
  ToArtist = 'TO_ARTIST',
  ToVenue = 'TO_VENUE'
}

export type ManualTicketSale = {
  __typename?: 'ManualTicketSale';
  _destroy?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  ticketsSold?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  _destroy?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  attachments?: Maybe<Array<SettlementAttachment>>;
  checkWireNr?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dateDue?: Maybe<Scalars['ISO8601Date']['output']>;
  datePaid?: Maybe<Scalars['ISO8601Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  payee?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<PaymentTypeEnum>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum PaymentTypeEnum {
  Cash = 'CASH',
  Check = 'CHECK',
  CreditCard = 'CREDIT_CARD',
  None = 'NONE',
  WireTransfer = 'WIRE_TRANSFER'
}

export enum SettlementTypeEnum {
  /** Settlement based on manual ticket sales entry */
  ManualGbor = 'MANUAL_GBOR',
  /** Settlement based on tickets sales at selected events in corresponding event group */
  TicketSalesEvents = 'TICKET_SALES_EVENTS'
}

export type SettlementContract = {
  __typename?: 'SettlementContract';
  identifier?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum SettlementTaxWithholdingTypeEnum {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type Me = {
  __typename?: 'Me';
  accounts?: Maybe<Array<Account>>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Account = {
  __typename?: 'Account';
  announcedEvents?: Maybe<Array<AnnouncedEvent>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AnnouncedEvent = {
  __typename?: 'AnnouncedEvent';
  accountId?: Maybe<Scalars['Int']['output']>;
  announceAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  announceName?: Maybe<Scalars['String']['output']>;
  artistName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventGroupId?: Maybe<Scalars['Int']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  footerContent?: Maybe<Scalars['String']['output']>;
  highlightedImage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  images?: Maybe<Scalars['String']['output']>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onSaleAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  promoter?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  support?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  ticketsUrl?: Maybe<Scalars['String']['output']>;
  triggeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
  venueRoomId?: Maybe<Scalars['Int']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type Sheet = {
  __typename?: 'Sheet';
  agent?: Maybe<Agent>;
  artistName?: Maybe<Scalars['String']['output']>;
  attendeeCount?: Maybe<Scalars['Int']['output']>;
  billing?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<OfferSheetContact>>;
  dealArtistGuarantee?: Maybe<Scalars['Float']['output']>;
  dealGborPercentage?: Maybe<Scalars['Float']['output']>;
  dealType?: Maybe<DealEnum>;
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventGroupId?: Maybe<Scalars['Int']['output']>;
  exclusivity?: Maybe<Scalars['String']['output']>;
  expenseCategories?: Maybe<Array<ExpenseCategory>>;
  headlinerGuarantee?: Maybe<Scalars['Float']['output']>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  listCount?: Maybe<Scalars['Int']['output']>;
  lists?: Maybe<Array<List>>;
  lockedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lockedBy?: Maybe<User>;
  merch?: Maybe<Scalars['String']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offerDate: Scalars['ISO8601Date']['output'];
  offerExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  pdfDownloadUrl?: Maybe<Scalars['String']['output']>;
  performanceDatesDescription?: Maybe<Scalars['String']['output']>;
  promoterName?: Maybe<Scalars['String']['output']>;
  promoterProfitPercentage?: Maybe<Scalars['Float']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  summary?: Maybe<Summary>;
  support?: Maybe<Scalars['String']['output']>;
  supportGuarantee?: Maybe<Scalars['Float']['output']>;
  taxPercentage?: Maybe<Scalars['Float']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  tickets?: Maybe<Array<OfferTicket>>;
  venueAddress?: Maybe<Scalars['String']['output']>;
  venueLogo?: Maybe<Scalars['String']['output']>;
  venueName?: Maybe<Scalars['String']['output']>;
  venueTimezone?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<Array<SheetVersion>>;
};

export type Agent = {
  __typename?: 'Agent';
  agencyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OfferSheetContact = {
  __typename?: 'OfferSheetContact';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ExpenseCategory = {
  __typename?: 'ExpenseCategory';
  editable: Scalars['Boolean']['output'];
  expenses: Array<Expense>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  totalExpenses: Scalars['Float']['output'];
  variable: Scalars['Boolean']['output'];
};

export type Expense = {
  __typename?: 'Expense';
  amount?: Maybe<Scalars['Float']['output']>;
  calculationType?: Maybe<VariableExpenseEnum>;
  calculationValue?: Maybe<Scalars['Float']['output']>;
  editable: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum VariableExpenseEnum {
  /** % of GBOR */
  GborPercentage = 'gbor_percentage',
  /** Per Attendee */
  PerAttendee = 'per_attendee',
  /** Per ticket */
  PerTicket = 'per_ticket'
}

export type List = {
  __typename?: 'List';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  gross: Scalars['Float']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  listType: ListTypeEnum;
  name: Scalars['String']['output'];
  projected: Scalars['Int']['output'];
};

export enum ListTypeEnum {
  /** Guest list */
  GuestList = 'guest_list',
  /** Paid list */
  PaidList = 'paid_list'
}

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Summary = {
  __typename?: 'Summary';
  artistBackend?: Maybe<Scalars['Float']['output']>;
  artistPotential?: Maybe<Scalars['Float']['output']>;
  breakeven?: Maybe<Scalars['Float']['output']>;
  fixedExpenses?: Maybe<Scalars['Float']['output']>;
  gbor?: Maybe<Scalars['Float']['output']>;
  netPotential?: Maybe<Scalars['Float']['output']>;
  overage?: Maybe<Scalars['Float']['output']>;
  promoterPotential?: Maybe<Scalars['Float']['output']>;
  promoterProfit?: Maybe<Scalars['Float']['output']>;
  splitPoint?: Maybe<Scalars['Float']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  totalExpenses?: Maybe<Scalars['Float']['output']>;
  variableExpenses?: Maybe<Scalars['Float']['output']>;
};

export type OfferTicket = {
  __typename?: 'OfferTicket';
  gross: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  projected: Scalars['Int']['output'];
  section?: Maybe<Scalars['String']['output']>;
};

export type SheetVersion = {
  __typename?: 'SheetVersion';
  id: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  versionName?: Maybe<Scalars['String']['output']>;
};

export type OrdersApiArguments = {
  cymbalAccountKey: Scalars['String']['input'];
  eventId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** EventOrdersCollection type */
export type EventOrdersCollection = {
  __typename?: 'EventOrdersCollection';
  /** A collection of paginated EventOrdersCollection */
  collection: Array<EventOrders>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export type EventOrders = {
  __typename?: 'EventOrders';
  address?: Maybe<Address>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customerInfo?: Maybe<Customer>;
  eventId: Scalars['Int']['output'];
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  ticketsInfo?: Maybe<Array<TicketInfo>>;
};

export type Customer = {
  __typename?: 'Customer';
  email: Scalars['String']['output'];
  emailOptedIn: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['BigInt']['output'];
  smsOptedIn: Scalars['Boolean']['output'];
};

export type TicketInfo = {
  __typename?: 'TicketInfo';
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  totalFee: Scalars['Int']['output'];
  totalPrice: Scalars['Int']['output'];
};

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  /** Current Page of loaded data */
  currentPage: Scalars['Int']['output'];
  /** The number of items per page */
  limitValue: Scalars['Int']['output'];
  /** The total number of items to be paginated */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int']['output'];
};

export type EventsApiArguments = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  cymbalAccountKey?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchScope?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Start date for searching events. Ignore id id is present. */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** PublicEventCollection type */
export type PublicEventCollection = {
  __typename?: 'PublicEventCollection';
  /** A collection of paginated PublicEventCollection */
  collection: Array<PublicEvent>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export type PublicEvent = {
  __typename?: 'PublicEvent';
  announceArtists?: Maybe<Array<PublicAnnounceArtist>>;
  announceImages: Array<AnnounceImage>;
  /** @deprecated Use `announce_artists` instead */
  artists?: Maybe<Array<Artist>>;
  buttonText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use venue.currency instead */
  currency?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `start_time_utc` */
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `door_time_utc` */
  doorTime?: Maybe<Scalars['Time']['output']>;
  doorTimeUtc?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Use `end_time_utc` */
  endTime?: Maybe<Scalars['Time']['output']>;
  endTimeUtc?: Maybe<Scalars['ISO8601DateTime']['output']>;
  footerContent?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `announce_images` instead */
  highlightedImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** @deprecated Use `announce_images` instead */
  images: Array<Scalars['String']['output']>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  openIn?: Maybe<Scalars['String']['output']>;
  priceMax?: Maybe<Scalars['Float']['output']>;
  priceMin?: Maybe<Scalars['Float']['output']>;
  promoter?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  scheduling?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `start_time_utc` */
  startTime?: Maybe<Scalars['Time']['output']>;
  startTimeUtc?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Use button_text */
  status?: Maybe<Scalars['String']['output']>;
  support?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tickets?: Maybe<Array<PublicTicket>>;
  ticketsUrl?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  venue?: Maybe<PublicVenue>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type PublicAnnounceArtist = {
  __typename?: 'PublicAnnounceArtist';
  /** @deprecated Use `links` field instead */
  applemusic?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  bandcamp?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  facebook?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  instagram?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  lastfm?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<PublicArtistLink>>;
  name: Scalars['String']['output'];
  /** @deprecated Use `links` field instead */
  songkick?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  spotify?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  twitter?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  website?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  wikipedia?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `links` field instead */
  youtube?: Maybe<Scalars['String']['output']>;
};

export type PublicArtistLink = {
  __typename?: 'PublicArtistLink';
  url: Scalars['String']['output'];
};

export type AnnounceImage = {
  __typename?: 'AnnounceImage';
  highlighted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  variants?: Maybe<Array<AnnounceImageVariant>>;
  /** @deprecated Use `variants` */
  versions?: Maybe<AnnounceImageVersions>;
};

export type AnnounceImageVariant = {
  __typename?: 'AnnounceImageVariant';
  src: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type AnnounceImageVersions = {
  __typename?: 'AnnounceImageVersions';
  cover?: Maybe<AnnounceImageVersion>;
  thumb?: Maybe<AnnounceImageVersion>;
};

export type AnnounceImageVersion = {
  __typename?: 'AnnounceImageVersion';
  src?: Maybe<Scalars['String']['output']>;
};

export type PublicTicket = {
  __typename?: 'PublicTicket';
  fee?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sectionName?: Maybe<Scalars['String']['output']>;
  sectionQuantity?: Maybe<Scalars['Int']['output']>;
};

export type PublicVenue = {
  __typename?: 'PublicVenue';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  /** Venue logo */
  logo?: Maybe<Logo>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `postal_code` instead */
  postal?: Maybe<Scalars['Int']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `timezone` instead */
  timeZone?: Maybe<Scalars['String']['output']>;
};

/** Venue logo */
export type Logo = {
  __typename?: 'Logo';
  /** Logo variants */
  variants?: Maybe<Array<ImageVariant>>;
};

/** Image variant */
export type ImageVariant = {
  __typename?: 'ImageVariant';
  /** Variant URI */
  src: Scalars['String']['output'];
  /** Variant name */
  variant: Scalars['String']['output'];
};

/** ProtectedEventCollection type */
export type ProtectedEventCollection = {
  __typename?: 'ProtectedEventCollection';
  /** A collection of paginated ProtectedEventCollection */
  collection: Array<ProtectedEvent>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export type ProtectedEvent = {
  __typename?: 'ProtectedEvent';
  artists?: Maybe<Array<Artist>>;
  currency?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doorTime?: Maybe<Scalars['Time']['output']>;
  endTime?: Maybe<Scalars['Time']['output']>;
  footerContent?: Maybe<Scalars['String']['output']>;
  highlightedImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priceMax?: Maybe<Scalars['Float']['output']>;
  priceMin?: Maybe<Scalars['Float']['output']>;
  promoter?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  salesQty: Scalars['Int']['output'];
  salesRevenue: Scalars['Float']['output'];
  scheduling?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  support?: Maybe<Scalars['String']['output']>;
  ticketsUrl?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  venue?: Maybe<PublicVenue>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type Ticketbuyer = {
  __typename?: 'Ticketbuyer';
  myCredits?: Maybe<Array<TicketbuyerCreditCache>>;
  myEvents?: Maybe<Array<TicketbuyerEvent>>;
};


export type TicketbuyerMyEventsArgs = {
  eventId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<EventsFilterEnum>;
};

export type TicketbuyerCreditCache = {
  __typename?: 'TicketbuyerCreditCache';
  account?: Maybe<PublicAccount>;
  balance?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type PublicAccount = {
  __typename?: 'PublicAccount';
  address?: Maybe<Address>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum EventsFilterEnum {
  /** Show past events, most recent first */
  Past = 'PAST',
  /** Show upcoming events, soonest first */
  Upcoming = 'UPCOMING'
}

export type TicketbuyerEvent = {
  __typename?: 'TicketbuyerEvent';
  announceDetail?: Maybe<AnnounceDetail>;
  /** Are donations accepted for this event */
  availableForDonation?: Maybe<Scalars['Boolean']['output']>;
  /** Is processing fee applied to ticket purchases */
  availableForProcessingFee?: Maybe<Scalars['Boolean']['output']>;
  /** Is sales tax applied to ticket purchases */
  availableForSalesTax?: Maybe<Scalars['Boolean']['output']>;
  /** Additional email content */
  confirmationEmailContent?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Use start_time instead */
  date: Scalars['ISO8601Date']['output'];
  /** Text shown on the donation button at checkout */
  donationButtonText?: Maybe<Scalars['String']['output']>;
  /** Description of what the donation supports */
  donationDescription?: Maybe<Scalars['String']['output']>;
  /** Time (with date) in UTC, use event's timezone for formatting */
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Door date and time in UTC, use event's timezone for formatting */
  doorTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time (with date) in UTC, use event's timezone for formatting */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** End date and time in UTC, use event's timezone for formatting */
  endTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** List of all event artists */
  eventArtists?: Maybe<Array<EventArtist>>;
  /** Event group details */
  eventGroup?: Maybe<EventGroup>;
  /** Additional content shown in the event's footer */
  footerContent?: Maybe<Scalars['String']['output']>;
  /** Full event slug name and key */
  fullSlug?: Maybe<Scalars['String']['output']>;
  highlightedImage?: Maybe<Scalars['String']['output']>;
  holdPreference?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Labels attached to the event */
  labels?: Maybe<Array<Label>>;
  /** Are PDF tickets mailed to attendees */
  mailPdfTickets?: Maybe<Scalars['Boolean']['output']>;
  /** Minimum age required to attend the event */
  minimumAge?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  orders?: Maybe<Array<TicketbuyerOrder>>;
  rescheduledFrom?: Maybe<RescheduleInfo>;
  /** Seating chart associated with the event */
  seatingChart?: Maybe<SeatingChart>;
  /** Whether will-call reminder emails are sent for this event */
  sendWillCallReminders?: Maybe<Scalars['Boolean']['output']>;
  /** Time (with date) in UTC, use event's timezone for formatting */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Start date and time in UTC, use event's timezone for formatting */
  startTimestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state?: Maybe<EventStateEnum>;
  status?: Maybe<Scalars['String']['output']>;
  /** Are there any tickets defined */
  ticketed?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum number of tickets that can be purchased in a single order */
  ticketLimit?: Maybe<Scalars['Int']['output']>;
  ticketSales?: Maybe<EventSales>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Event venue details */
  venue?: Maybe<Venue>;
  venueName?: Maybe<Scalars['String']['output']>;
  /** Event venue room details */
  venueRoom?: Maybe<VenueRoom>;
  venueTimezone?: Maybe<Scalars['String']['output']>;
};


export type TicketbuyerEventEventArtistsArgs = {
  artistId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketbuyerOrder = {
  __typename?: 'TicketbuyerOrder';
  ccType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliveryMethod?: Maybe<Scalars['String']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastFourDigits?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  platformFee?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  processingFee?: Maybe<Scalars['Float']['output']>;
  refundStatus?: Maybe<RefundStatusEnum>;
  salesTax?: Maybe<Scalars['Float']['output']>;
  tickets?: Maybe<Array<TicketbuyerTicket>>;
};

export enum RefundStatusEnum {
  Credited = 'CREDITED',
  Donated = 'DONATED',
  None = 'NONE',
  RefundChoose = 'REFUND_CHOOSE',
  Refunded = 'REFUNDED'
}

export type TicketbuyerTicket = {
  __typename?: 'TicketbuyerTicket';
  fee?: Maybe<Scalars['Float']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  seat?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type RescheduleInfo = {
  __typename?: 'RescheduleInfo';
  date: Scalars['ISO8601Date']['output'];
  /** Date is irrelevant, only time part is used */
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date is irrelevant, only time part is used */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date is irrelevant, only time part is used */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Global configuration that can be fetched from the server. */
export type Config = {
  __typename?: 'Config';
  /** Cognito configuration. */
  cognito?: Maybe<CognitoConfig>;
};

/** Cognito configuration that can be fetched from the server. */
export type CognitoConfig = {
  __typename?: 'CognitoConfig';
  /** The client ID of the Cognito user pool. This client allows USER_PASSWORD_AUTH flow. */
  clientId?: Maybe<Scalars['String']['output']>;
  /** The region of the Cognito user pool. */
  region?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  app?: Maybe<AppMutation>;
  /** @deprecated Use generateSettlementPdf on AppSchema (x-vp-api: admin) instead. Removal in 7.20a. */
  generateSettlementPdf?: Maybe<GeneratePdfPayload>;
  organizationSignupMutation?: Maybe<OrganizationSignupMutationPayload>;
  requestAuthTokenMutation?: Maybe<RequestAuthTokenMutationPayload>;
  signinUserMutation?: Maybe<SigninUserMutationPayload>;
  ticketBuyer?: Maybe<TicketbuyerMutation>;
  tokenAuthMutation?: Maybe<TokenAuthMutationPayload>;
  /** @deprecated Use saveSettlementDeals, saveSettlementEvents, saveSettlementTaxDetails, saveSettlementPayments, saveSettlementCustomExpenses and saveSettlementManualTicketSales on AppSchema (x-vp-api: admin) instead. Removal in 7.20a. */
  updateEventArtistSettlement?: Maybe<UpdateEventArtistSettlementPayload>;
};


export type MutationGenerateSettlementPdfArgs = {
  input: GeneratePdfInput;
};


export type MutationOrganizationSignupMutationArgs = {
  input: OrganizationSignupMutationInput;
};


export type MutationRequestAuthTokenMutationArgs = {
  input: RequestAuthTokenMutationInput;
};


export type MutationSigninUserMutationArgs = {
  input: SigninUserMutationInput;
};


export type MutationTokenAuthMutationArgs = {
  input: TokenAuthMutationInput;
};


export type MutationUpdateEventArtistSettlementArgs = {
  input: UpdateEventArtistSettlementInput;
};

export type AppMutation = {
  __typename?: 'AppMutation';
  resetPassword?: Maybe<ResetPasswordMutationPayload>;
};


export type AppMutationResetPasswordArgs = {
  input: ResetPasswordMutationInput;
};

/** Autogenerated input type of ResetPasswordMutation */
export type ResetPasswordMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of ResetPasswordMutation. */
export type ResetPasswordMutationPayload = {
  __typename?: 'ResetPasswordMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of GeneratePdf */
export type GeneratePdfInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If set to true, PDF will be regenerated even if it already exists */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  settlementId: Scalars['Int']['input'];
};

/** Autogenerated return type of GeneratePdf. */
export type GeneratePdfPayload = {
  __typename?: 'GeneratePdfPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  settlement: Settlement;
};

/** Autogenerated input type of OrganizationSignupMutation */
export type OrganizationSignupMutationInput = {
  acceptTos?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationName: Scalars['String']['input'];
};

/** Autogenerated return type of OrganizationSignupMutation. */
export type OrganizationSignupMutationPayload = {
  __typename?: 'OrganizationSignupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of RequestAuthTokenMutation */
export type RequestAuthTokenMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of RequestAuthTokenMutation. */
export type RequestAuthTokenMutationPayload = {
  __typename?: 'RequestAuthTokenMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of SigninUserMutation */
export type SigninUserMutationInput = {
  /** AccessToken, obtained from cognito. This is used when the user identified by cognito UUID already exists in the db. */
  accessToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDToken, obtained from cognito. Used when the user can't be identified by cognito UUID  */
  idToken?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SigninUserMutation. */
export type SigninUserMutationPayload = {
  __typename?: 'SigninUserMutationPayload';
  /** Authentication token */
  authToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors, if any */
  errors?: Maybe<Array<VpError>>;
  /** URL to redirect to after sign in */
  returnTo?: Maybe<Scalars['String']['output']>;
};

export type VpError = {
  __typename?: 'VpError';
  /** Full error message */
  message: Scalars['String']['output'];
  /** Path to the field that caused the error, or `base` */
  path?: Maybe<Scalars['String']['output']>;
};

export type TicketbuyerMutation = {
  __typename?: 'TicketbuyerMutation';
  chooseRefundOptionMutation?: Maybe<ChooseRefundOptionMutationPayload>;
  resendTicketConfirmation?: Maybe<ResendTicketConfirmationPayload>;
};


export type TicketbuyerMutationChooseRefundOptionMutationArgs = {
  input: ChooseRefundOptionMutationInput;
};


export type TicketbuyerMutationResendTicketConfirmationArgs = {
  input: ResendTicketConfirmationInput;
};

/** Autogenerated input type of ChooseRefundOptionMutation */
export type ChooseRefundOptionMutationInput = {
  action: RefundActionEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
};

export enum RefundActionEnum {
  Credit = 'CREDIT',
  Donate = 'DONATE',
  Refund = 'REFUND'
}

/** Autogenerated return type of ChooseRefundOptionMutation. */
export type ChooseRefundOptionMutationPayload = {
  __typename?: 'ChooseRefundOptionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  order?: Maybe<TicketbuyerOrder>;
};

/** Autogenerated input type of ResendTicketConfirmation */
export type ResendTicketConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
};

/** Autogenerated return type of ResendTicketConfirmation. */
export type ResendTicketConfirmationPayload = {
  __typename?: 'ResendTicketConfirmationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of TokenAuthMutation */
export type TokenAuthMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  loginToken: Scalars['String']['input'];
};

/** Autogenerated return type of TokenAuthMutation. */
export type TokenAuthMutationPayload = {
  __typename?: 'TokenAuthMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  token?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEventArtistSettlement */
export type UpdateEventArtistSettlementInput = {
  address?: InputMaybe<AddressAttributes>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customExpenses?: InputMaybe<Array<CustomExpenseAttributes>>;
  deals?: InputMaybe<Array<DealAttributes>>;
  eventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['ID']['input'];
  manualTicketSales?: InputMaybe<Array<ManualTicketSaleAttributes>>;
  payments?: InputMaybe<Array<PaymentAttributes>>;
  settlementType?: InputMaybe<SettlementTypeEnum>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxLabel?: InputMaybe<Scalars['String']['input']>;
  taxWithholding?: InputMaybe<Scalars['Boolean']['input']>;
  taxWithholdingAmount?: InputMaybe<Scalars['Float']['input']>;
  taxWithholdingType?: InputMaybe<SettlementTaxWithholdingTypeEnum>;
};

export type AddressAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type CustomExpenseAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  deductedType?: InputMaybe<CustomExpenseDeductedTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  due?: InputMaybe<CustomExpenseDueEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DealAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED */
  dealId?: InputMaybe<Scalars['Int']['input']>;
  dealType?: InputMaybe<DealEnum>;
  expenseAmount?: InputMaybe<Scalars['Float']['input']>;
  firstAmount?: InputMaybe<Scalars['Float']['input']>;
  hitAmount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
  showTicketSales?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ManualTicketSaleAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  ticketsSold: Scalars['Int']['input'];
};

export type PaymentAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkWireNr?: InputMaybe<Scalars['String']['input']>;
  dateDue?: InputMaybe<Scalars['ISO8601Date']['input']>;
  datePaid?: InputMaybe<Scalars['ISO8601Date']['input']>;
  deletions?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  payee?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaymentTypeEnum>;
};

/** Autogenerated return type of UpdateEventArtistSettlement. */
export type UpdateEventArtistSettlementPayload = {
  __typename?: 'UpdateEventArtistSettlementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  settlement?: Maybe<Settlement>;
};


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    